export { default as SingleSignOn } from './SingleSignOn'
